export class AreaCode {
    id: number;
    countryCode: number;
    code: number;
    description: string;
}
